import { useTranslation } from 'react-i18next';

/**
 * Replaces `Pages/Error/Error500.cshtml`.
 *
 * Rendered inside `AuthShell`, not the app shell — the same choice the Razor
 * page made by using the login card and backdrop. A 500 can be the app shell
 * itself failing, and reaching for the navigation to draw the page that reports
 * the failure is how one error becomes two.
 *
 * This is also where `UseExceptionHandler` re-executes to, so it must render
 * without a session and without any data of its own.
 */
export function ServerErrorPage() {
  const { t } = useTranslation();

  return (
    <div className="row justify-content-center">
      <div className="col-11 col-md-8 col-lg-6 col-xl-4">
        <div className="login-card p-4 p-md-6 bg-dark bg-opacity-50 translucent-dark rounded-4 text-center">
          <h1 className="display-1 fw-bold text-white mb-3">5 0 0</h1>
          <h4 className="text-white mb-2">
            {t('Error.500.Title', 'Internal Server Error')}
          </h4>
          <p className="text-white opacity-50 mb-4">
            {t(
              'Error.500.Message',
              'Something went wrong on our end. Please try again in a moment.',
            )}
          </p>

          {/* A full page load, not a client-side route change: whatever failed
              may have left the app's state unusable, so this starts it over. */}
          <a className="btn btn-primary" href="/">
            {t('Error.BackHome', 'Back to home')}
          </a>

          <div className="opacity-50 text-white small mt-4">
            {t('Error.500.Reassurance', "We're working to fix the problem. Thank you for your patience.")}
          </div>
        </div>
      </div>
    </div>
  );
}
